// import { UserCheck, UserX } from "lucide-react";

// /* Optional: Indian number formatter */
// const formatIndianNumber = (num) =>
//   num?.toLocaleString("en-IN") || 0;

// const ElectionOverviewCard = ({ overview }) => {
//   if (!overview) return null;

//   const {
//     totalVoters,
//     activeVoters,
//     inactiveVoters,
//     maleVoters,
//     femaleVoters,
//     newVoters,
//     averageAge,
//     villages,
//     totalBooths,
//   } = overview;

//   const totalGender = maleVoters + femaleVoters;

//   const malePercent = totalGender
//     ? Math.round((maleVoters / totalGender) * 100)
//     : 0;

//   const femalePercent = totalGender
//     ? Math.round((femaleVoters / totalGender) * 100)
//     : 0;

//   return (
//     <div className="absolute top-[30%] left-2 p-1 card-wrapper !rounded-xl w-[320px] z-[20]">

//       {/* HEADER */}
//       <h3 className="text-lg font-semibold text-center text-[#123865] mb-1">
//         Election Overview
//       </h3>

//       {/* TOTAL VOTERS */}
//       <div className="text-2xl font-bold text-center text-[#0b65c2] mb-1">
//         {formatIndianNumber(totalVoters)}
//       </div>
//       <div className="text-sm text-gray-500 text-center mb-2">
//         Total Voters (ER Data)
//       </div>

//       {/* ACTIVE / INACTIVE */}
//       <div className="card-wrapper !rounded-xl px-2 py-1 mb-1 shadow-sm">
//         <div className="text-sm font-medium text-gray-700 mb-2 text-center">
//           Voting Participation
//         </div>
//         <div className="flex justify-around items-center text-sm font-semibold">
//           <div className="flex items-center gap-1 text-green-600">
//             <UserCheck size={14} />
//             {formatIndianNumber(activeVoters)}
//           </div>
//           <div className="flex items-center gap-1 text-red-500">
//             <UserX size={14} />
//             {formatIndianNumber(inactiveVoters)}
//           </div>
//         </div>
//       </div>

//       {/* GENDER DISTRIBUTION */}
//       <div className="card-wrapper !rounded-xl px-2 py-1 mb-1 shadow-sm">
//         <div className="text-sm font-medium text-gray-700 mb-1 text-center">
//           Gender Distribution
//         </div>
//         <div className="flex justify-around items-center text-sm font-semibold">
//           <div className="flex flex-col items-center">
//             <span className="text-gray-600">Male</span>
//             <span className="text-[#0b65c2]">{malePercent}%</span>
//           </div>
//           <div className="flex flex-col items-center">
//             <span className="text-gray-600">Female</span>
//             <span className="text-blue-600">{femalePercent}%</span>
//           </div>
//         </div>
//       </div>

//       {/* OTHER STATS */}
//       <div className="card-wrapper !rounded-xl px-3 py-2 text-center shadow-sm space-y-1">
//         <div className="text-sm text-gray-700">
//           New Voters (18–25)
//         </div>
//         <div className="text-md font-semibold text-[#1a237e]">
//           {formatIndianNumber(newVoters)}
//         </div>

//         <div className="text-sm text-gray-700 mt-2">
//           Average Age
//         </div>
//         <div className="text-md font-semibold text-[#1a237e]">
//           {averageAge}
//         </div>

//         <div className="text-sm text-gray-700 mt-2">
//           Villages / Booths
//         </div>
//         <div className="text-md font-semibold text-[#1a237e]">
//           {villages} / {totalBooths}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ElectionOverviewCard;


import { UserCheck, UserX, MapPin, Users, Landmark } from "lucide-react";
import { useTranslation } from "react-i18next";

/* Optional: Indian number formatter */
const formatIndianNumber = (num) =>
  num?.toLocaleString("en-IN") || 0;

const ElectionOverviewCard = ({ overview }) => {
  const { t } = useTranslation();
  if (!overview) return null;

  const isStateOverview = !!overview.totalAssemblies;

  /* ---------- NORMAL SURVEY (ER DATA) ---------- */
  if (!isStateOverview) {
    const {
      totalVoters,
      activeVoters,
      inactiveVoters,
      maleVoters,
      femaleVoters,
      newVoters,
      averageAge,
      villages,
      totalBooths,
    } = overview;

    const totalGender = maleVoters + femaleVoters;

    const malePercent = totalGender
      ? Math.round((maleVoters / totalGender) * 100)
      : 0;

    const femalePercent = totalGender
      ? Math.round((femaleVoters / totalGender) * 100)
      : 0;

    return (
      <div className="absolute top-[30%] left-2 p-1 card-wrapper !rounded-xl w-[320px] z-[20]">
        <h3 className="text-lg font-semibold text-center text-[#123865] mb-1">
           {t("electionOverview")}
        </h3>

        <div className="text-2xl font-bold text-center text-[#0b65c2] mb-1">
          {formatIndianNumber(totalVoters)}
        </div>
        <div className="text-sm text-gray-500 text-center mb-2">
           {t("totalVoters")} (ER Data)
        </div>

        <div className="card-wrapper !rounded-xl px-2 py-1 mb-1 shadow-sm">
          <div className="text-sm font-medium text-gray-700 mb-2 text-center">
            {t("votingParticipation")}
          </div>
          <div className="flex justify-around items-center text-sm font-semibold">
            <div className="flex items-center gap-1 text-green-600">
              <UserCheck size={14} />
              {formatIndianNumber(activeVoters)}
            </div>
            <div className="flex items-center gap-1 text-red-500">
              <UserX size={14} />
              {formatIndianNumber(inactiveVoters)}
            </div>
          </div>
        </div>

        <div className="card-wrapper !rounded-xl px-2 py-1 mb-1 shadow-sm">
          <div className="text-sm font-medium text-gray-700 mb-1 text-center">
             {t("genderDistribution")}
          </div>
          <div className="flex justify-around items-center text-sm font-semibold">
            <div className="flex flex-col items-center">
              <span className="text-gray-600"> {t("male")}</span>
              <span className="text-[#0b65c2]">{malePercent}%</span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-gray-600"> {t("female")}</span>
              <span className="text-blue-600">{femalePercent}%</span>
            </div>
          </div>
        </div>

        <div className="card-wrapper !rounded-xl px-3 py-2 text-center shadow-sm space-y-1">
          <div className="text-sm text-gray-700"> {t("newVoters")} (18–25)</div>
          <div className="text-md font-semibold text-[#1a237e]">
            {formatIndianNumber(newVoters)}
          </div>

          <div className="text-sm text-gray-700 mt-2"> {t("averageAge")}</div>
          <div className="text-md font-semibold text-[#1a237e]">
            {averageAge}
          </div>

          <div className="text-sm text-gray-700 mt-2">
            Villages / Booths
          </div>
          <div className="text-md font-semibold text-[#1a237e]">
            {villages} / {totalBooths}
          </div>
        </div>
      </div>
    );
  }

  /* ---------- STATE SURVEY (STATE DATA) ---------- */

  const {
    totalVoters,
    activeVoters,
    inactiveVoters,
    maleVoters,
    femaleVoters,
    newVoters,
    averageAge,
    // totalDistricts,
    totalAssemblies,
    totalParties,
    // totalCandidates,
  } = overview;

  const totalGender = maleVoters + femaleVoters;

  const malePercent = totalGender
    ? Math.round((maleVoters / totalGender) * 100)
    : 0;

  const femalePercent = totalGender
    ? Math.round((femaleVoters / totalGender) * 100)
    : 0;

  return (
    <div className="absolute top-[35%] left-2 p-1 card-wrapper !rounded-xl w-[320px] z-[20]">
      <h3 className="text-lg font-semibold text-center text-[#7c1d1d] mb-1">
        {t("electionOverview")}
      </h3>

      {/* <div className="grid grid-cols-2 gap-2 mb-2 text-center">
        <div className="card-wrapper p-2">
          <div className="text-xs text-gray-500">Assemblies</div>
          <div className="font-bold">{totalAssemblies}</div>
        </div>
        <div className="card-wrapper p-2">
          <div className="text-xs text-gray-500">Districts</div>
          <div className="font-bold">{totalDistricts}</div>
        </div>
        <div className="card-wrapper p-2">
          <div className="text-xs text-gray-500">Parties</div>
          <div className="font-bold">{totalParties}</div>
        </div>
        <div className="card-wrapper p-2">
          <div className="text-xs text-gray-500">Candidates</div>
          <div className="font-bold">{totalCandidates}</div>
        </div>
      </div> */}

      <div className="text-2xl font-bold text-center text-[#0b65c2] mb-1">
        {formatIndianNumber(totalVoters)}
      </div>
      <div className="text-sm text-gray-500 text-center mb-2">
         {t("totalVoters")} (State Data)
      </div>

      <div className="card-wrapper !rounded-xl px-2 py-1 mb-1 shadow-sm">
        <div className="text-sm font-medium text-gray-700 mb-2 text-center">
          {t("votingParticipation")}
        </div>
        <div className="flex justify-around items-center text-sm font-semibold">
          <div className="flex items-center gap-1 text-green-600">
            <UserCheck size={14} />
            {formatIndianNumber(activeVoters)}
          </div>
          <div className="flex items-center gap-1 text-red-500">
            <UserX size={14} />
            {formatIndianNumber(inactiveVoters)}
          </div>
        </div>
      </div>

      <div className="card-wrapper !rounded-xl px-2 py-1 mb-1 shadow-sm">
        <div className="text-sm font-medium text-gray-700 mb-1 text-center">
          {t("genderDistribution")}
        </div>
        <div className="flex justify-around items-center text-sm font-semibold">
          <div className="flex flex-col items-center">
            <span className="text-gray-600">{t("male")}</span>
            <span className="text-[#7c1d1d]">{malePercent}%</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-gray-600">{t("female")}</span>
            <span className="text-blue-600">{femalePercent}%</span>
          </div>
        </div>
      </div>

      <div className="card-wrapper !rounded-xl px-3 py-2 text-center shadow-sm space-y-1">
        <div className="text-sm text-gray-700">{t("newVoters")}</div>
        <div className="text-md font-semibold text-[#1a237e]">
          {formatIndianNumber(newVoters)}
        </div>

        <div className="text-sm text-gray-700 mt-2">{t("averageAge")}</div>
        <div className="text-md font-semibold text-[#1a237e]">{averageAge}</div>
        <div className="text-sm text-gray-700 mt-2">
          {t("assembliesParties")}
        </div>
        <div className="text-md font-semibold text-[#1a237e]">
          {totalAssemblies} / {totalParties}
        </div>
      </div>
    </div>
  );
};

export default ElectionOverviewCard;
